import { render, staticRenderFns } from "./MortgageDetail.vue?vue&type=template&id=98ebdd92&"
import script from "./MortgageDetail.vue?vue&type=script&lang=js&"
export * from "./MortgageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports